import { Button, Card, Col, Form, message, Row, Space } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { CheckOutlined } from '@ant-design/icons';

import { useQuery } from '../../../shared/hooks/use-query';
import { CommonQueryParamKey } from '../../../shared/models/common-query-params';
import { Feature } from '../../../shared/models/features';
import { PolicyUpsertForm, PolicyUpsertFormValues } from '../../components/policy-upsert-form';
import { translationNamespace } from '../../constants/translation-resources';
import { useCreatePolicyMutation } from '../../data/mutations/policy-mutations';
import { AppResourcePaths } from '../../../shared/constants/app-resources';
import { PolicyUpsert } from '../../models/policy';

export const PolicyNewView: FC = () => {
  const { t } = useTranslation(translationNamespace);
  const { push: routerPush } = useHistory();
  const [form] = Form.useForm<PolicyUpsertFormValues>();
  const query = useQuery();
  const mutation = useCreatePolicyMutation();

  const parsedPrev = query.get(CommonQueryParamKey.PREV);
  const prevUrl = parsedPrev ?? AppResourcePaths.policies;

  const submit = (values: PolicyUpsertFormValues) => {
    const newPolicy = values as Omit<PolicyUpsert, 'id'>;

    mutation.mutate(newPolicy, {
      onSuccess: () => {
        message.success(t('policies.shared.createSuccessMessage'));
        routerPush(parsedPrev ?? `${AppResourcePaths.policies}`);
      },
    });
  };

  const triggerSubmit = () => {
    form.submit();
  };

  return (
    <Row gutter={[16, 24]}>
      <Col span={24}>
        <Card title={t(`${Feature.SHARED}:details`)}>
          <PolicyUpsertForm form={form} onSubmit={submit} />
        </Card>
      </Col>
      <Col>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            icon={<CheckOutlined />}
            loading={mutation.isLoading}
            onClick={triggerSubmit}
          >
            {t(`${Feature.SHARED}:create`)}
          </Button>
          <Link to={prevUrl}>
            <Button htmlType="button" size="large">
              {t(`${Feature.SHARED}:cancel`)}
            </Button>
          </Link>
        </Space>
      </Col>
    </Row>
  );
};
